// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_33CLL","list":"style_list_e_Y4P","listItem":"style_listItem_nXdY-"};